/** @format */

import React, { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const KeywordSearch = ({
    inputValue,
    onInputChange,
    onClearSearchFilter,
    onFilterContent,
    displayableItemsLength,
    totalItemsLength,
}) => {
    const inputRef = useRef(null);

    useEffect(() => {
        const handleEnterPressed = (event) => {
            var key = event.code;
            if (key === "Enter") {
                onFilterContent(event.target.value);
            }
        };

        if (inputRef.current) {
            inputRef.current.addEventListener("keyup", handleEnterPressed);
        }

        return () => {
            if (inputRef.current) {
                inputRef.current.removeEventListener(
                    "keyup",
                    handleEnterPressed
                );
            }
        };
    }, [inputRef]);

    return (
        <>
            <div className='keywordSearchContainer'>
                <div className='cardContainer'>
                    <div className="cardTitle">Search for a page</div>
                    <div className='searchTitle'>Keywords</div>
                    <div className='searchBar'>
                        <input
                            ref={inputRef}
                            type='text'
                            value={inputValue}
                            onInput={onInputChange}
                        />

                    {inputValue && (
                        <span
                        className='clearText'
                        onClick={onClearSearchFilter}
                        >
                            <FontAwesomeIcon icon='fas fa-times' />
                        </span>
                    )}

                    <button  onClick={() => onFilterContent(inputRef.current.value)}>Search</button>
                    </div>
                </div>
            </div>

            {/* {totalItemsLength > 0 && ( */}
                <div className='keywordSearchContainerDisplayCount'>
                    Displaying {displayableItemsLength} of {totalItemsLength}{" "}
                    result(s)
                </div>
            {/* )} */}
        </>
    );
};
